import { stackLabels } from "./labelStacking";
import { drawPill } from "./positionPills";
import { layoutCard, drawCard } from "./positionCard";
import {
  POSITION_CARD_FONT_WEIGHT,
  POSITION_CARD_X_RATIO,
  POSITION_PILL_LEFT_PX,
  positionFont,
} from "./positionConstants";

const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));

// On the entry line at 40 % of the pane, kept inside it
const layoutCards = (cards, { pane, measure, font, sizes }) =>
  cards.map(({ position, y }) => {
    const { cells, width } = layoutCard(position, { measure, font, sizes });
    const x = clamp(
      Math.round(pane.width * POSITION_CARD_X_RATIO),
      POSITION_PILL_LEFT_PX,
      pane.width - width - POSITION_PILL_LEFT_PX,
    );

    return {
      position,
      cells,
      rect: { x, y: y - sizes.cardHeight / 2, width, height: sizes.cardHeight },
    };
  });

/**
 * Pills of the lines on the left, right on their lines, and the cards of
 * the positions on their entry lines. Cards that would overlap (several
 * positions of one pair at close prices) go one under another, so every
 * close button stays clickable.
 *
 * @param {object} textLayer
 * @param {{ lines: object[], cards: object[] }} scene - from resolvePositionScene
 * @param {object} params
 * @param {{ width: number, height: number }} params.pane
 * @param {object} params.sizes - from positionSizesFor
 * @param {{ colors: object, fontFamily: string }} params.theme
 * @param {{ id: string|number, isPressed: boolean } | null} params.highlight - close button under the pointer
 * @returns {Array<{ positionId: string|number, rect: object }>} close buttons for the hit-test
 */
export const drawPositionLabels = (textLayer, scene, { pane, sizes, theme, highlight }) => {
  const pillFont = positionFont(sizes.pillFontSize, theme.fontFamily);

  scene.lines.forEach((line) => drawPill(textLayer, line, { font: pillFont, sizes, colors: theme.colors }));

  // Phones have no cards and no card sizes
  if (scene.cards.length === 0) return [];

  const cardFont = positionFont(sizes.cardFontSize, theme.fontFamily, POSITION_CARD_FONT_WEIGHT);
  const cards = layoutCards(scene.cards, { pane, measure: textLayer.measure, font: cardFont, sizes });

  stackLabels(cards, pane.height);

  return cards.map((card) => {
    const { id } = card.position;
    const rect = drawCard(textLayer, card, {
      font: cardFont,
      sizes,
      colors: theme.colors,
      highlight: highlight?.id === id ? highlight : null,
    });

    return { positionId: id, rect };
  });
};
